<i class="tooltip-icon" (click)="tooltip.toggle()">
  <i><img [src]="tooltipIcon" /></i>
  <i #tooltip="matTooltip"
     [matTooltip]="infoMessage"
     matTooltipPosition="right"
     matTooltipClass="common-tooltip-message">
  </i>
</i>
